import {
  OfferSortBy,
  OfferSortByDirection,
  ProductFiltersT,
  ProductT,
  SearchParamsT,
  SearchProductsParamsT,
  SkuT,
} from '@lambda/apis/src/catalog-v2/types';
import { ProductCategoryWarranty } from '@lambda/apis/src/category/types';
import { ParsedUrlQuery } from 'querystring';

type BreadcrumbT = { name: string; pk: string };

interface SharedCollectionPageProps {
  filters: ProductFiltersT;
  total: number;
  collectionName: string;
  breadcrumb: BreadcrumbT[] | null;
  pk: string | null;
  fixedFilters: SearchProductsParamsT;
  searchParams: SearchParamsT;
  handle: string | null;
  msCatalogEnabled: boolean;
}

type CollectionPageType =
  | 'MS_CATALOG_NAV_COLLECTION_PAGE'
  | 'MS_CATALOG_BRAND_COLLECTION_PAGE'
  | 'MS_CATALOG_CATEGORY_COLLECTION_PAGE';

export type DealsCollectionPageProps = SharedCollectionPageProps & {
  type: 'MS_CATALOG_DEALS';
  products: SkuT[]; // Exclusive for Deals Collection Page
  spotlightedProducts: SkuT[]; // Exclusive for Deals Collection Page
};

type CatalogCollectionPageProps = SharedCollectionPageProps & {
  type: CollectionPageType;
  products: ProductT[];
  spotlightedProducts: null;
};

export type CollectionPageProps =
  | DealsCollectionPageProps
  | CatalogCollectionPageProps;

export type SelectedFilters = {
  categories: { id: string; name: string }[];
  brands: { id: string; name: string }[];
  variants: Record<string, string[]>;
  priceRange?: { min: number; max: number };
};

export type useCollectionPageResult = CollectionPageProps & {
  categoryName: string;
  categoryWarrantyInfo: ProductCategoryWarranty | null;
  selectedFilters: SelectedFilters | null;
  toggleFilter: (type: FilterType, id: string, name: string) => void;
  toggleVariantFilter: (variantId: string, _value: string) => void;
  clearFilters: () => void;
  clearCategoryFilters: () => void;
  onPriceRangeChange: (min: number, max: number) => void;
  sortByFilter: { sortBy: OfferSortBy; sortDirection: OfferSortByDirection };
  onSortByChange: (
    sortBy: OfferSortBy,
    sortDirection: OfferSortByDirection,
  ) => void;
  goToPage: (page: number) => Promise<void>;
  getPageHref: (page: number) => string;
  currentPage: number;
  pageCount: number;
  isLoadingMore: boolean;
  isApplyingFilters: boolean;
};

export enum FilterType {
  CATEGORY = 'categories',
  BRAND = 'brands',
  VARIANT = 'variants',
}

export type GetServerSidePropsParams = {
  slug: string[];
  [key: string]: string | string[] | undefined;
};

export type BuildParamsT = {
  selectedFilters: SelectedFilters;
  fixedFilters: SearchProductsParamsT;
  sort?: { sortBy: OfferSortBy; sortDirection: OfferSortByDirection };
  offset?: number;
  limit?: number;
  page?: number;
  defaultPriceRange?: { min: number; max: number };
  routerQuery?: ParsedUrlQuery;
};
